<template>
  <div class="page-template">
    <div class="page-title">{{title}}</div>
     <search-form-template :searchOptions="searchOptions" :toolConfig="toolConfig" >
        </search-form-template>
    <div class="imgbox" >
      <span v-for="(v,i) in imgMessage" :key="i" ><img :src="v.url" alt="" @click="urlss()"></span>
    </div>
     <file-dialog :fileList="fileDialogData.fileList" :url="fileDialogData.url"  @fileDialogClose="fileDialogClose" >
     </file-dialog>
     <el-dialog  center width="800px">
      <form-template ref="formTemplate"
                     @success="formSuccess" @getDetailSuccess="getDetailSuccess" >
        <template v-slot:fromSlot="data">
          <slot name="fromSlot" :column="data.column"></slot>
        </template>
      </form-template>
    </el-dialog>
  </div>
</template>
<script>
import searchFormTemplate  from '@/components/template/searchFormTemplate';
import fileDialog from '@/components/template/fileDialog';
import formTemplate from '@/components/template/formTemplate'
import api from "@/config/api";

export default {
  components: {
    searchFormTemplate,fileDialog,formTemplate
  },
  data() {
    return {
       title:"",
       count: 0,
       dialogVisible: false,
       fileDialogData:{url:"",fileList:[]},
       dialogVisibility: false,
       imgMessage:[],
        searchOptions: {
        simple: [
          { label:"图片来源",prop: 'name', type: 'select', data: [],url:api.system.role},
           { prop: 'storeId', type: 'select', data: [],url:api.system.seStore},
            ],
        },
        toolConfig: [
         {
          label: '上传图片',
          code: 'insert',
          callback:this.showFileDialog
        },
         {
          label: '批量删除',
          code: 'delete'
        },
      ],
    }
  },
  methods: {
       getImg(){
           this.$axios.fetchPost(api.system.imgCode + '/list').then(data=>{
               this.imgMessage=data.data
               this.imgMessage.map(item=>{
               this.url = item.url;
               })
           })
       },
    //图片点击放大
      fileDialogClose(){
          this.dialogVisible=false;
          this.fileDialogData = {url:'',fileList:[]};
    },
      urlss(){
        this.dialogVisible=true;
        this.fileDialogData = {url:this.url,fileList:[this.url],file:this.url};
    },

      formSuccess () {
      // this.dialogFormVisible = false;
    },
     getDetailSuccess (formModel) {
      this.formOptions.callback && this.formOptions.callback(formModel);
    },
    showFileDialog(){
      alert()
       this.dialogVisibility = true;
    }
  },
  created(){
    this.getImg()
  },
  mounted(){
        this.title=document.title,
        this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
      },
};
</script>
<style scoped>
.page-template .imgbox{
  max-height: calc(100vh - 185px);
  overflow: auto;
  display: flex;
  background: #f0f0f0;
  padding: 0 10px;
  flex-wrap: wrap;
 
}
.page-template .imgbox span{
    width: 19.2%;
    height: 100px;
    border: 1px solid#eee;
    margin: 5px;
    border-radius: 8px;
}
.page-template .imgbox span img{
  width: 100%;
  height: 100%;
}

</style>




// WEBPACK FOOTER //
// src/page/system/maintain/Img.vue